import React, { useMemo } from "react";
import { motion } from "framer-motion";

export const Particles = ({ count = 26 }) => {
  const dots = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: Math.random() * 3 + 1,
        dur: Math.random() * 6 + 6,
        delay: Math.random() * 5,
        color: Math.random() > 0.5 ? "#0047FF" : "#B026FF",
      })),
    [count]
  );

  return (
    <div className="pointer-events-none absolute inset-0 z-[1] overflow-hidden">
      {dots.map((d) => (
        <motion.span
          key={d.id}
          className="absolute rounded-full"
          style={{
            left: `${d.left}%`,
            top: `${d.top}%`,
            width: d.size,
            height: d.size,
            background: d.color,
            boxShadow: `0 0 ${d.size * 4}px ${d.color}`,
          }}
          animate={{ y: [0, -30, 0], opacity: [0.2, 0.9, 0.2] }}
          transition={{ duration: d.dur, delay: d.delay, repeat: Infinity, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
};

export default Particles;
